module.exports = __webpack_public_path__ + "static/media/8.2769d1e1.JPG";